module.exports = __webpack_public_path__ + "img/LogoCONTPAQiFirma_Positivo2.04e99c90.png";